import { useMemo, useState } from "react";
import { Graph_QL, useSystem, useUser } from "../../../Services"
import { useAppSelector } from "../../../Store";
import { CheckBox, NewModal } from "../../BaseComponents"
import { UsersWithGroups } from "../../../Services/Agrisys_GqlDataCaller/UserCalls/GQLCalls/workerListCalls";
import { useTranslation } from "react-i18next";
import { ButtonTypes } from "../../../Definitions";
import { colors, fonts } from "../../../Styles";
import { Pages } from "../../../Navigation/root";
import NewButton from "../../BaseComponents/newButton";

export interface WorkerListModalProps {
    worker: UsersWithGroups
    closeModal: () => void
}

export function WorkerListModal({ worker, closeModal }: WorkerListModalProps) {
    const { t } = useTranslation();
    const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
    const domain = useMemo(() => (Graph_QL.ObjToString({ domain: farm })), [farm]);
    const connection = useMemo(() => (Graph_QL.create({ domain: farm })), [farm]);

    const { setUserAttentionEmailSystems, getWorkerList } = useUser()
    const { data: systemsState } = useSystem(connection);

    const systems = useMemo(() => {
        return systemsState?.[domain]?.data || [];
    }, [domain, systemsState]);

    const [userSystems, setUserSystems] = useState(systems.map(e => ({ ...e, isChecked: worker.attention_email_systems?.includes(e.system_id) ?? false })));

    function handleSave() {
        const systemsToAdd: number[] = userSystems.filter(e => e.isChecked).map(e => e.system_id);
        setUserAttentionEmailSystems(farm, worker.username, systemsToAdd)
            .then(() => {
                getWorkerList(farm, true).then(e=>{if(!e) getWorkerList(farm)});
                closeModal();
            })
            .catch(() => { });
    }

    return (
        <NewModal
            header={t(`menuHeaders.${Pages.globalSettings}`, {defaultValue: "settings"})}
            subHeader={`${t("user.userName", { defaultValue: "username" })}: ${worker.username}`}
            predefinedButtons={{
                onClose: closeModal
            }}
            mainContent={
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "40px", marginTop: "10px" }}>
                    <div style={{
                        borderTop: "2px solid " + colors.blueDarkSecondary,
                        borderBottom: "2px solid " + colors.blueDarkSecondary,
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        flexDirection: "column",
                        gap: "10px",
                        padding: "10px 10px",
                    }}>
                    <p style={{...fonts.header, ...fonts.fontSize3, ...fonts.textShadow, color: colors.greyLightTertiary, textAlign: "center"}}>
                        {t("user.email", { defaultValue: "email" }) + " " + t("menuHeaders.attentions", { defaultValue: "attentions" })}
                    </p>                        
                        {userSystems.map(system =>
                            <CheckBox
                                text={system.name}
                                isChecked={system.isChecked}
                                onChange={() => {
                                    setUserSystems(prev =>
                                        prev.map(s =>
                                            s.system_id === system.system_id ? { ...s, isChecked: !s.isChecked } : s
                                        ))
                                }}
                                key={system.system_id}
                            />
                        )}
                    </div>
                    <NewButton
                        content={t("buttons.save", { defaultValue: "save" })}
                        onClick={handleSave}
                    />
                </div>
            }
        />
    );
}